import React, { useState } from "react";
import { FaChevronDown, FaChevronRight } from "react-icons/fa"; // npm install react-icons

export default function SVTableSales({ data }) {
  const [expanded, setExpanded] = useState({});

  const dataGrouped = groupByCodiCompra(data);

  // Funció per sumar tots els imports
  const totalImport = dataGrouped.reduce(
    (acc, compra) => acc + (compra.AmountTotal || 0),
    0
  );

  function groupByCodiCompra(tickets) {
    const groups = {};

    for (const t of tickets) {
      const id = t.CodiCompra || "Sin ID";

      if (!groups[id]) {
        groups[id] = {
          CodiCompra: id,
          Show: t.Show || "",
          Session: t.Session,
          Time: t["Ticket Sold On"],
          Name: t.Name,
          AmountTotal: 0,
          NumEntrades: 0,
          Entradas: [],
        };
      }

      groups[id].Entradas.push(t);
      groups[id].AmountTotal += Number(t.Amount || 0);
      groups[id].NumEntrades += 1;
    }

    return Object.values(groups);
  }

  return (
    <>
      <h5> Cobraments</h5>
      <table className="table table-hover table-bordered align-middle">
        <thead className="table-light">
          <tr className="table-light fw-bold">
            <td colSpan="6" className="text-end">
              Total
            </td>
            <td className="text-end">{totalImport.toFixed(2)} €</td>
          </tr>
          <tr>
            <th style={{ width: "40px" }}></th>
            <th>Hora</th>
            <th>Nom</th>
            <th>Obra</th>
            <th>Sesió</th>
            <th>Núm.</th>
            <th className="text-end">Import</th>
          </tr>
        </thead>

        <tbody>
          {dataGrouped.map((compra, idx) => (
            <React.Fragment key={idx}>
              <tr
                onClick={() =>
                  setExpanded((prev) => ({ ...prev, [idx]: !prev[idx] }))
                }
                style={{
                  cursor: "pointer",
                  backgroundColor: idx % 2 === 0 ? "#f9f9f9" : "white",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#e8f4ff")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor =
                    idx % 2 === 0 ? "#f9f9f9" : "white")
                }
              >
                <td className="text-center" style={{ width: "40px" }}>
                  {expanded[idx] ? <FaChevronDown /> : <FaChevronRight />}
                </td>
                <td>{compra.Time}</td>
                <td>{compra.Name}</td>
                <td>{compra.Show}</td>
                <td>{compra.Session}</td>
                <td>{compra.NumEntrades}</td>
                <td className="text-end">{compra.AmountTotal?.toFixed(2)} €</td>
              </tr>

              {expanded[idx] && (
                <tr>
                  <td colSpan="7" className="p-0">
                    <table className="table table-sm mb-0">
                      <thead className="table-secondary">
                        <tr>
                          <th>Fila/Seient</th>
                          <th>Nom descompte</th>
                          <th>Descompte</th>
                          <th className="text-end">Import</th>
                        </tr>
                      </thead>
                      <tbody>
                        {compra.Entradas.map((t, i) => (
                          <tr
                            key={i}
                            style={{
                              cursor: "pointer",
                              backgroundColor:
                                i % 2 === 0 ? "#f9f9f9" : "white",
                              transition: "background-color 0.2s",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#e8f4ff")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                i % 2 === 0 ? "#f9f9f9" : "white")
                            }
                          >
                            <td>{t.Fila + "/" + t.Seient}</td>
                            <td>
                              {t["Discount Name"] ? t["Discount Name"] : "-"}
                            </td>
                            <td>
                              {t["Discount Type"] === "Percent"
                                ? t["Discount Amount"] + " %"
                                : t["Discount Amount"] + " €"}
                            </td>
                            <td className="text-end">
                              {t.Amount?.toFixed(2)} €
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </>
  );
}
